import { TouchableOpacity, View } from 'react-native';
import { twMerge } from 'tailwind-merge';
import { InfoTextProps } from './AssetField/AssetField.types';
import { InfoIcon } from './Icons';
import Typography from './Text/Typography';

export function InfoText({
  infoText,
  hasError,
  inputClass,
}: {
  infoText: InfoTextProps;
  hasError: boolean;
  inputClass: string;
}) {
  const infoIconColor =
    infoText?.infoLeftType === 'secondary' ? 'fill-neutral-400' : 'fill-white';
  const infoLeftColor =
    infoText?.infoLeftType === 'secondary' ? 'text-neutral-400' : 'text-white';
  const infoRightColor =
    infoText?.infoRightType === 'secondary' ? 'text-neutral-400' : 'text-white';
  return (
    <View className={inputClass}>
      <View className="flex-row items-center">
        {infoText.infoIcon && (
          <InfoIcon
            className={twMerge(
              'mr-1',
              hasError ? 'fill-price-red' : infoIconColor
            )}
          />
        )}
        <TouchableOpacity onPress={() => infoText.onPress?.()}>
          <Typography
            variant="body"
            size="small"
            weight="regular"
            className={twMerge('mr-1', hasError ? 'text-error' : infoLeftColor)}
          >
            {infoText.infoLeft}
          </Typography>
        </TouchableOpacity>
        {infoText.infoRight && (
          <Typography
            variant="body"
            size="small"
            weight="regular"
            className={twMerge(
              'mr-1',
              hasError ? 'text-error' : infoRightColor
            )}
          >
            {infoText.infoRight}
          </Typography>
        )}
      </View>
    </View>
  );
}
